import { RouteObject } from 'react-router-dom'
import ParceirosPage from '@/pages/parceiros-admin/ParceirosPage'
import DocumentosMateriaisPage from '@/pages/materiais/DocumentosMateriaisPage'

/**
 * Rotas do A12 (Onda 7.1–7.2) — Parceiros e Documentos e Materiais.
 *
 * ATENÇÃO (integração): `parceiros` (placeholder "Em desenvolvimento") e
 * `documentos-materiais` (apontando para `DocumentosListPage`) também estão registrados
 * em `router/rotas/a02.tsx`; o A12 não edita aquele arquivo. Como o `a02` entra antes na
 * concatenação, os registros de lá vencem — na integração o coordenador remove as duas
 * linhas do `a02.tsx` para que estas páginas assumam.
 */
const rotasA12: RouteObject[] = [
  { path: 'parceiros', element: <ParceirosPage /> },
  { path: 'documentos-materiais', element: <DocumentosMateriaisPage /> },
]

export default rotasA12
